import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addApiToken } from '../../../../features/apitoken/apitoken.slice';

const APIPage = () => {
  const sites = [
    'Facebook API',
    'Instagram API',
    'Twitter API',
    'Pinterest API',
    'LinkedIn API',
    'Tik Tok API',
    'Youtube API',
  ];

  const analytics = [
    'Google Analytics',
    'Facebook Pixel',
    'Zoho Mail',
    'Mail Chimp',
  ];

  return (
    <div className="bg-lightblue">
      <div className="py-1 px-5 border flex">
        <div className="flex flex-[0.65] space-x-4">
          Connect social media networks API
        </div>
        <p>
          Filters <i className="fa-solid fa-filter"></i>
        </p>
      </div>

      <div className="p-4 space-y-5">
        {sites.map((el) => (
          <SocialAPI site={el} />
        ))}

        <div className="pt-8 space-y-5">
          <p>Analytics APIs</p>

          {analytics.map((el) => (
            <AnalyticsAPI site={el} />
          ))}
        </div>
      </div>
    </div>
  );
};

const SocialAPI = ({ site }) => {
  const [apiKey, setApiKey] = useState({
    secret_id: '',
    secret_code: '',
    _type: site,
  });
  const dispatch = useDispatch();
  return (
    <div className="flex w-[800px]">
      <div className="w-full bg-white border border-gray-400 h-8 flex items-center px-2">
        {site}
      </div>
      <input
        type="text"
        class="bg-white border border-gray-400 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 h-8"
        placeholder="Secret ID"
        onChange={(e) => {
          setApiKey({
            ...apiKey,
            secret_id: e.target.value,
          });
        }}
        required
      />
      <input
        type="text"
        class="bg-white border border-gray-400 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 h-8"
        placeholder="Secret Code"
        onChange={(e) => {
          setApiKey({
            ...apiKey,
            secret_code: e.target.value,
          });
        }}
        required
      />
      <button
        className="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium text-sm p-2 text-center w-[230px] h-8 rounded-md ml-2"
        onClick={() => dispatch(addApiToken(apiKey))}
      >
        Save
      </button>
    </div>
  );
};

const AnalyticsAPI = ({ site }) => {
  return (
    <div className="flex w-[800px]">
      <div className="w-full bg-white border border-gray-400 h-8 flex items-center px-2">
        {site}
      </div>
      <input
        type="text"
        class="bg-white border border-gray-400 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 h-8"
        placeholder="Secret ID"
        required
      />

      <button className="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium text-sm p-2 text-center w-[230px] h-8 rounded-md ml-2">
        Save
      </button>
    </div>
  );
};
export default APIPage;
